import { render, staticRenderFns } from "./customer-send-mail-button.vue?vue&type=template&id=43a01ae1&"
import script from "./customer-send-mail-button.vue?vue&type=script&lang=js&"
export * from "./customer-send-mail-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports